import * as types from "./types";

export const getCompanyApplicantProfileRequest = (payload) => ({
  type: types.GET_COMPANY_APPLICANT_PROFILE_REQUEST,
  payload,
});

export const getCompanyApplicantProfileResponse = (payload) => ({
  type: types.GET_COMPANY_APPLICANT_PROFILE_RESPONSE,
  payload,
});

export const clearCompanyApplicantProfile = () => ({
  type: types.CLEAR_COMPANY_APPLICANT_PROFILE,
});
